<template>
  <LayoutPrimary>
    <div :style="headerContainerStyle">
      <template v-if="!sideMenuIsVisible">
        <SelectPopoverPrimary :optionContainerStyle="optionContainerStyle"
                              :options="dropdownOptions"
                              @select="selectDropdownOption">
          <template v-slot:select>
            <IconSecondary content="menu"
                           :fontSize="iconStyle.fontSize"
                           :style="iconStyle" />
          </template>
        </SelectPopoverPrimary>
      </template>
      <HeaderLargePrimary>
        Settings
      </HeaderLargePrimary>
    </div>
    <div :style="containerStyle">
      <div :style="sideMenuContainerStyle">
        <SideMenu :options="sideMenuOptions"
                  @collapse="() => { sideMenuIsVisible = false; }"
                  @open="() => { sideMenuIsVisible = true; }" />
      </div>
      <div :style="sideMenuPlaceholderStyle" />
      <div :style="contentContainerStyle">
        <router-view />
      </div>
    </div>
  </LayoutPrimary>
</template>

<script>
  import HeaderLargePrimary from '@modules/text/header-large-primary'
  import IconSecondary from '@modules/icon/icon-secondary'
  import LayoutPrimary from '@modules/v2/layout/layout-primary'
  import SelectPopoverPrimary from '@modules/select/select-popover-primary'
  import SideMenu from '@settings/modules/side-menu'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'SettingsView',
    components: {
      HeaderLargePrimary,
      IconSecondary,
      LayoutPrimary,
      SelectPopoverPrimary,
      SideMenu,
    },
    data: function () {
      return {
        containerStyle: {
          display: 'flex',
          margin: '0 auto',
          maxWidth: Layout.container.primary.maxWidth,
          padding: Layout.container.primary.padding,
          position: 'relative',
          width: '100%',
        },
        contentContainerStyle: {
          flex: 1,
          width: '100%',
        },
        dropdownOptions: [],
        headerContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          height: '78px',
          margin: '32px auto 0 auto',
          maxWidth: Layout.container.primary.maxWidth,
          padding: Layout.container.primary.padding,
          width: '100%',
        },
        iconStyle: {
          display: 'block',
          fontSize: FontStyle.size.lg,
          marginRight: Layout.space.xs,
        },
        optionContainerStyle: {
          width: '180px',
        },
        sideMenuIsVisible: false,
        sideMenuOptions: {
          user: [
            {
              content: 'person',
              text: 'Profile & Preference',
              to: { name: 'settings-profile', },
            },
            {
              content: 'language',
              text: 'Language & Region',
              to: { name: 'settings-locale', },
            },
          ],
          admin: [
            {
              content: 'settings',
              text: 'Workspace Settings',
              to: { name: 'admin-settings-workspace', },
            },
            {
              content: 'supervised_user_circle',
              text: 'User Management',
              to: { name: 'admin-settings-users', },
            },
          ],
        },
      };
    },
    mounted: function () {
      this.dropdownOptions = [...this.sideMenuOptions.user.map(elem => {
            return { label: elem.text, to: elem.to };
          }),
          ...(this.isAdmin ? this.sideMenuOptions.admin.map(elem => {
            return { label: elem.text, to:elem.to };
          }) : []),
      ];
    },
    computed: {
      ...mapGetters('tenantUser', ['isAdmin']),
      sideMenuContainerStyle: function () {
        return {
          position: 'absolute',
          top: 0,
          width: this.sideMenuIsVisible ? '240px' : 0,
        };
      },
      sideMenuPlaceholderStyle: function () {
        return {
          width: this.sideMenuIsVisible ? '240px' : 0,
        };
      },
    },
    methods: {
      goTo: function (name) {
        if (this.$route.name !== name) {
          this.$router.push({ name: name });
        }
      },
      selectDropdownOption: function (index) {
        this.goTo(this.dropdownOptions[index].to.name);
      },
    },
  };
</script>
